<template>
    <div class="channel">
      <van-search
        v-model="value"
        shape="round"
        class="channel-search"
        background="transparent"
        placeholder="请输入搜索关键词"
      />
      <div class="channel-menu">
        <div class="channel-menu__item" @click="dj(19)">
          <img src="../assets/images/youxi.png" alt="">
          <p>金牛区</p>
        </div>
        <div class="channel-menu__item" @click="dj(25)">
          <img src="../assets/images/zixun.png" alt="">
          <p>武侯区</p>
        </div>
        <div class="channel-menu__item" @click="dj(34)">
          <img src="../assets/images/haohuo.png" alt="">
          <p>锦江区</p>
        </div>
        <div class="channel-menu__item" @click="dj(20)">
          <img src="../assets/images/jingtu.png" alt="">
          <p>青羊区</p>
        </div>
        <div class="channel-menu__item" @click="dj(27)">
          <img src="../assets/images/yingyin.png" alt="">
          <p>成华区</p>
        </div>
        <div class="channel-menu__item" @click="dj(30)">
          <img src="../assets/images/zhixun.png" alt="">
          <p>温江区</p>
        </div>
        <div class="channel-menu__item" @click="dj(32)">
          <img src="../assets/images/chihe.png" alt="">
          <p>郫都区</p>
        </div>
        <div class="channel-menu__item" @click="dj(26)">
          <img src="../assets/images/miliao.png" alt="">
          <p>双流区</p>
        </div>
        <div class="channel-menu__item" @click="dj(31)">
          <img src="../assets/images/youxi.png" alt="">
          <p>新津区</p>
        </div>
        <div class="channel-menu__item" @click="dj(29)">
          <img src="../assets/images/zixun.png" alt="">
          <p>青白红区</p>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'channel',
  data () {
    return {
      value: ''
    }
  },
  methods: {
      dj (num) {
          this.$router.push({ path: '/video', query: { cid: num } });
      }
  }
}
</script>

<style lang="scss">
.channel {
  min-height: 100vh;
  background: url('../assets/images/page-bg.png') no-repeat;
  background-size: cover;
  padding-bottom: 50px;
  .van-search__content {
    background-color: rgba(255, 255, 255, 0.2);
  }
  &-search {
    .van-field__left-icon {
      i {
        color: #ffffff;
      }
    }
    .van-field__control {
      color: #ffffff;
    }
  }
  &-menu {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    padding: 10px;
    &__item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 8px;
      height: 120px;
      img {
        width: 60px;
        height: 60px;
        margin-bottom: 8px;
      }
    }
  }
}
</style>
